var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.309,33.3a1.666,1.666,0,0,0,0,2.358l7.334,7.334a1.666,1.666,0,0,0,2.361,0l7.334-7.334A1.668,1.668,0,0,0,48.979,33.3l-4.486,4.484V20.669a1.669,1.669,0,0,0-3.339,0V37.786L36.67,33.3a1.671,1.671,0,0,0-2.361,0Z",
    transform: "translate(-25.017 -19)",
    fill: "#2e93b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.669,57A1.667,1.667,0,0,0,18,58.669V64.34a6.024,6.024,0,0,0,6.015,6.015H47.592a6.025,6.025,0,0,0,6.021-6.015V58.669a1.669,1.669,0,0,0-3.339,0V64.34A2.681,2.681,0,0,1,47.6,67.016H24.014a2.681,2.681,0,0,1-2.676-2.676V58.669A1.667,1.667,0,0,0,19.669,57Z",
    transform: "translate(-18 -35.855)",
    fill: "#2e93b2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.67fb681139e4b14795886448058cba9b.svg";
export { ForwardRef as ReactComponent };